<template>
    <div class="full-search-2 eclip-search italian-search hero-search-radius shadow mt-5" :dir="$i18n.locale == 'ar'? 'rtl':'ltr'">
        <div class="hero-search-content">
            <div class="row" >
                <div class="col-lg-3 col-md-4 col-sm-12 b-r">
                    <div class="form-group borders">
                        <div class="position-relative">
                            <input type="text" v-model="name" class="form-control border-0 ps-5" :placeholder="t('Exhibitname')">
                            <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                <span class="svg-icon text-primary svg-icon-2hx">
                                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"/>
                                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-2 col-md-3 col-sm-12">
                    <div class="form-group borders border-start">
                        <div class="position-relative ps-5">
                            <Multiselect v-model="selectedRating" :options="ptypes" :no-options-text="t('noOptions')" :placeholder="t('Category')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                            <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                <span class="svg-icon text-primary svg-icon-2hx">
                                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
                                        <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12">
                  <div class="form-group borders border-start">
                    <div class="position-relative ps-5">
                      <Multiselect
                        :no-options-text="t('noOptions')"
                        v-model="selectedCountry"
                        :options="countries"
                        :placeholder="t('Country')"
                        class="form-control px-0 border-0"
                        append-to-body
                        open-direction="bottom"
                        :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}"
                      />
                      <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                        <span class="svg-icon text-primary svg-icon-2hx">
                          <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.3" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" fill="currentColor"/>
                            <path d="M12 4C13.38 4 14.5 5.12 14.5 6.5C14.5 7.88 13.38 9 12 9C10.62 9 9.5 7.88 9.5 6.5C9.5 5.12 10.62 4 12 4ZM12 11C14.76 11 17 13.24 17 16H7C7 13.24 9.24 11 12 11Z" fill="currentColor"/>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                
                <div class="col-lg-2 col-md-3 col-sm-12" >
                    <div class="form-group borders border-start">
                        <div class="position-relative ps-5">
                            <Multiselect v-model="selectedCity" :options="location" :no-options-text="t('noOptions')" :placeholder="t('City')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                            <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                <span class="svg-icon text-primary svg-icon-2hx">
                                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z" fill="currentColor"/>
                                        <path d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z" fill="currentColor"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-12">
                    <div class="form-group">
                        <button type="button" @click="searchExhibits" class="btn btn-primary fw-medium full-width">{{ t('Search') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';
import { ref, onMounted,watch } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import {useI18n} from "vue-i18n";
const router = useRouter();
const name = ref("");
const selectedRating = ref(null);
const selectedCity = ref(null);

const  {t} = useI18n();
const { locale } = useI18n();
const location = ref([]);
const ptypes = ref([]);

const countries = ref([]);
const selectedCountry = ref(null);

const fetchCountries = async () => {
  try {
    const response = await axios.get("/countries", {
      params: { lang: locale.value }
    });

    if (response.data && Array.isArray(response.data.data)) {
      countries.value = response.data.data
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .map(country => ({
          label: country.name,
          value: country.id
        }));
    }
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};
const fetchCities = async () => {
  if (!selectedCountry.value) return;

  try {
    const response = await axios.get(`/countries/${selectedCountry.value}?lang=${locale.value}`);
    const cities = response.data.data.cities || [];
    location.value = cities.map(city => city.name);
  } catch (error) {
    console.error("Error fetching cities:", error);
  }
};
const fetchRatings = async () => {
  try {
    const response = await axios.get("/ratings", {
      params: { lang: locale.value} 
    });
    ptypes.value = response.data
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .map(rating => rating.name); 
  } catch (error) {
    console.error("Error fetching ratings:", error);
  }
};

onMounted(() => {
  fetchCountries();
  fetchRatings();
});

watch(locale, () => {
  fetchCountries();
  fetchRatings();
  if (selectedCountry.value) fetchCities();
});

watch(selectedCountry, () => {
  fetchCities();
});

const searchExhibits = () => {
    router.push({
        path: `/${locale.value}/exhibits/search`,
        query: {
            name: name.value || null,
            rating: selectedRating.value || null,
            city: selectedCity.value,
            country: selectedCountry.value,
            lang: locale.value
        }
    });
};
</script>
<style scoped>
@media (max-width: 768px) {
  .multiselect {
    width: 100%;
    font-size: 16px;
  }
}
</style>

<style>
@media (max-width: 768px) {
  .multiselect {
    width: 100%;
    font-size: 16px;
  }
}
.multiselect-option.is-selected {
  background-color: #6A715D;
  color: white;
}
.multiselect-option {
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    font-size: var(--ms-option-font-size, 1rem);
    justify-content: flex-start;
    line-height: var(--ms-option-line-height, 1.375);
    padding: var(--ms-option-py, .5rem) var(--ms-option-px, .75rem);
    text-align: left;
    text-decoration: none;
}

html[dir="rtl"] .multiselect-option {
  direction: rtl;
  text-align: right;
}

html[dir="ltr"] .multiselect-option {
  direction: ltr;
  text-align: left;
}
.multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed, #C48B6E);
    color: var(--ms-option-color-selected-pointed, #fff);
}
</style>